import { Box, Center, Flex, Table as MantineTable } from '@mantine/core';
import { forwardRef } from 'react';
import './table.overrides.css';
import { clx } from './clx';
import classes from './table.module.css';
import { useGoodTableContext } from './table-context';
export const GoodTableRoot = forwardRef(({ empty, scrollable = true, onScrollChange, scrollAreaRef, containerProps, minWidth = 400, children, variant = 'default', leftPadded = true, ...props }, ref) => {
    const { attachTableRef, attachOuterRef, attachScrollRef, scrollPosition, overflowX, onScrollPositionChange } = useGoodTableContext();
    return (<Flex h='100%' w='100%' data-variant={variant} style={{
            overflow: scrollable ? 'hidden' : 'none',
        }} flex={1} maw={props.maw} pos='relative' direction='column' ref={ref} bg={!empty ? (props.bg ?? 'var(--mantine-color-body)') : undefined} className={clx(classes.root, 'goodTable__root', props.className)} {...containerProps}>
        {empty ? (<Center w='100%' h='100%'>
            {empty}
          </Center>) : (<MantineTable.ScrollContainer minWidth={minWidth} w='100%' h='100%' pos='relative' ref={(ref_) => {
                attachOuterRef(ref_);
            }} scrollAreaProps={{
                onScrollPositionChange: (position) => {
                    onScrollPositionChange(position);
                    if (onScrollChange) {
                        onScrollChange(position);
                    }
                },
                viewportRef: (ref) => {
                    if (scrollAreaRef) {
                        // @ts-expect-error
                        scrollAreaRef.current = ref;
                    }
                    attachScrollRef(ref);
                },
                styles: {
                    viewport: {
                        paddingBottom: overflowX > 0 ? undefined : 0,
                    },
                },
            }}>
            <Box pos='relative' w='100%' h='100%'>
              <MantineTable horizontalSpacing='sm' verticalSpacing='sm' ref={(ref_) => {
                attachTableRef(ref_);
                if (typeof ref === 'function') {
                    ref(ref_);
                }
                else if (ref) {
                    ref.current = ref_;
                }
            }} style={{
                borderCollapse: 'separate',
                borderSpacing: 0,
            }} className={classes.table} data-scroll-y={scrollPosition.y > 0 ? 'true' : undefined} data-scroll-x={scrollPosition.x > 0 ? 'true' : undefined} data-scroll-x-end={scrollPosition.x < overflowX ? 'true' : undefined} data-left-padded={leftPadded ? 'true' : undefined} highlightOnHoverColor='var(--mantine-color-gray-2)' {...props} bg={props.bg ?? 'var(--mantine-color-body)'}>
                {children}
              </MantineTable>
            </Box>
          </MantineTable.ScrollContainer>)}
      </Flex>);
});
